<template>
    <div>
       <!-- 条形码 -->
       <img :src='detail.QRCode'>
    </div>
</template>

<script>
export default {
    props:{
        detail:Object
    }
}
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>